import React from "react";
import { Col, Row, Image } from "react-bootstrap";
import ImgDoc from "../../assets/images/doc.png";
import icNext from "../../assets/images/ic-arrow-next.svg";
import { truncateText } from "../../constant/TruncateText";

const RowItemMobile = ({
  item,
  linkTitle = "GO TO THE LINK",
  lg = 3,
  xs = 12,
}: {
  item: any;
  linkTitle?: string;
  lg?: number;
  xs?: number;
}) => {
  return (
    <>
      <Col lg={lg} xs={xs} className='mob' style={{ marginBottom: '10px' }}>
        {/* <div className="col-sm-3 mob"> */}
        <div style={styles.codeofconductmob}>
          <Row>
            <Col xs={3}>
              <a
                href={item?.materialBase64}
                rel='noopener noreferrer'
                target='_blank'
              >
                <img src={ImgDoc} style={styles.img} alt='icon' />
              </a>
            </Col>
            <Col xs={9}>
              <h3 style={styles.title}>{truncateText(item?.title, 40)}</h3>
              {/* <a href={item?.externalUrl} rel='noopener noreferrer' target="_blank" style={styles.link}>  <b>  {linkTitle}  {"  "} &gt;  </b> </a> */}

              {item.moduleId !== 4 && item.moduleId !== 4 ? (
                <a
                  href={item?.externalUrl}
                  rel='noopener noreferrer'
                  target='_blank'
                  style={styles.link}
                >
                  {linkTitle}
                  {'  '}{' '}
                  <span style={{ fontSize: '18px' }}>
                    <Image
                      src={icNext}
                      style={{
                        width: '15px',
                        height: '15px'
                      }}
                    />
                  </span>
                </a>
              ) : (
                <a
                  href={item?.materialBase64}
                  rel='noopener noreferrer'
                  target='_blank'
                  style={styles.link}
                >
                  {linkTitle}
                  {'  '}{' '}
                  <span style={{ fontSize: '18px' }}>
                    <Image
                      src={icNext}
                      style={{
                        width: '15px',
                        height: '15px'
                      }}
                    />
                  </span>
                </a>
              )}
            </Col>
          </Row>
        </div>
        {/* </div> */}
      </Col>
    </>
  );
};

const styles: any = {
  img: {
    backgroundColor: "#ececec33",
    padding: "14px",
    borderRadius: "50%",
  },
  title: {
    fontFamily: "Georama-Regular",
    fontSize: "18px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.44,
    letterSpacing: "normal",
  },

  link: {color: "#e31837", 
        //  float: "right", 
        fontFamily: "Saira", 
        fontSize: "12px", 
        fontWeight: "bold", 
         textDecoration: "none",
        bottom: "10px",
        right: "10px"
        },

  contents: {
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.57,
    letterSpacing: "normal",
  },

  codeofconduct: {
    border: "1px solid #eee",
    padding: "20px 10px 30px 10px",
    marginBottom: "20px",
  },

  codeofconductmob: {
    border: "1px solid #eee",
    padding: "25px 20px",
    MarginBottom: "10px",
  },
};

export default RowItemMobile;
